// extracted by mini-css-extract-plugin
export default {"form":"A8P4_3","section":"zMSL2x","section-title":"SJzSSe"};